import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { openQuestionnaireWithAccess } from "web_myplann/Api/Nsure/openQuestionnaire";
import type { TimelineOrigin } from "web_myplann/NotificationCenter/Utils/notificationOrigin";
import type { TimelineNavigation } from "web_myplann/NotificationCenter/Utils/resolveTimelineNavigation";
import { device, NavigationTypes } from "web_myplann/Utils/device";

export type UsePerformTimelineNavigationOptions = {
	origin?: TimelineOrigin;
};

export const usePerformTimelineNavigation = (
	options?: UsePerformTimelineNavigationOptions,
): ((navigation: TimelineNavigation) => void) => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const origin = options?.origin;

	return useCallback(
		(navigation: TimelineNavigation) => {
			switch (navigation.kind) {
				case "bridge":
					device.navigationRequest(NavigationTypes.ZZJ, navigation.url);
					return;
				case "questionnaire":
					void openQuestionnaireWithAccess(navigation.request, queryClient);
					return;
				case "route":
					navigate(
						navigation.path,
						origin ? { state: { from: origin } } : undefined,
					);
			}
		},
		[navigate, queryClient, origin],
	);
};
